import { render, staticRenderFns } from "./HeadNavHomeSchool.vue?vue&type=template&id=6b7c2d1c&scoped=true&"
import script from "./HeadNavHomeSchool.vue?vue&type=script&lang=js&"
export * from "./HeadNavHomeSchool.vue?vue&type=script&lang=js&"
import style0 from "./HeadNavHomeSchool.vue?vue&type=style&index=0&id=6b7c2d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c2d1c",
  null
  
)

export default component.exports